// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3Pirw","inputDescription":"styles_inputDescription__1SSL-"};